module.exports = "/packs/009-82e0b15f686f2888a822d093734900a9.jpg";